<template>
  <el-dialog
    :title="data[0].id ? $t('text.edit_facility') : $t('text.add_facility')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    v-if="dialogVisible"
    @close="closeDialog()"
    width="450px"
  >
    <BuildingTree
      ref="buildingTree"
      :data="data"
      :allBuildings="allBuildings"
      @loadingChange="loadingChange"
      @saveSuccessfully="saveSuccessfully"
    />
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading"
        >{{
          data[0].id
            ? $t('text.save').toUpperCase()
            : $t('text.add').toUpperCase()
        }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BuildingTree from '@/components/manage/building/BuildingTree.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      data: [
        {
          id: 0,
          label: '',
          type: 'building',
          children: [
            {
              id: Math.random(),
              label: '',
              type: 'floor',
              children: [
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                },
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  props: {
    allBuildings: {
      type: Array,
      require: true
    }
  },
  components: {
    BuildingTree
  },
  methods: {
    loadingChange(val) {
      this.loading = val
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.data = [
        {
          id: 0,
          label: '',
          type: 'building',
          children: [
            {
              id: Math.random(),
              label: '',
              type: 'floor',
              children: [
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                },
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                }
              ]
            }
          ]
        }
      ]
      this.dialogVisible = false
    },
    submit() {
      this.$refs.buildingTree.submit()
    },
    saveSuccessfully() {
      this.$emit('updateBuilding')
      this.closeDialog()
    }
  }
}
</script>
